import { I18N } from 'aurelia-i18n';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { autoinject } from 'aurelia-framework';
import { DataTableCellFormatBaseValueConverter } from './DataTableCellFormatBase';
import { SystemService } from 'DataAccessLayer/Services/SystemService';

@autoinject
export class KanbanFieldFormatBaseValueConverter {

    protected i18n: I18N = null;
    constructor(i18n: I18N) {
        this.i18n = i18n;
    }
    toView(value: string, obj: any, schemaColumns: any) {
        let result: string = value;
        if (ObjectHelper.IsNotNullAndUndefined(value) && ObjectHelper.IsNotNullAndUndefined(obj)) {
            let starts: Array<number> = [];
            let ends: Array<number> = [];
            let fieldNames: Array<string> = [];
            for (var i = 0; i < value.length; i++) {
                if (value[i] === "{") starts.push(i);
                if (value[i] === "}") ends.push(i);
            }
            if (starts.length > 0 && starts.length == ends.length) {
                for (var i = 0; i < starts.length; i++) {
                    if (starts[i] >= 0 && starts[i] < ends[i] && ends[i] <= value.length) {
                        fieldNames.push(value.substring(starts[i] + 1, ends[i]));
                    }
                }
            }
            if (fieldNames.length > 0) {
                let dataTableCellFormat: DataTableCellFormatBaseValueConverter = new DataTableCellFormatBaseValueConverter(this.i18n);
                for (var i = 0; i < fieldNames.length; i++) {
                    let schemaColumn: Array<any> = schemaColumns.filter((item) => item.ColumnName == fieldNames[i] || (item.ColumnName + '_MainProjection_Icon') == fieldNames[i]);
                    if (ObjectHelper.IsNotNullAndUndefined(schemaColumn) && schemaColumn.length > 0) {
                        let enumItem: any = null;
                        switch (schemaColumn[0].Type_FK) {

                            case 8:
                            case 40:
                                if (ObjectHelper.ObjectIs(schemaColumn[0].EnumItems) && ObjectHelper.ArrayIs(schemaColumn[0].EnumItems.Items)) {
                                    enumItem = ObjectHelper.GetFirstItemOfArrayByProperty(schemaColumn[0].EnumItems.Items, 'Id', obj[fieldNames[i]]);
                                }
                                break;
                            case 21:
                                if (ObjectHelper.ArrayIs(schemaColumn[0].EnumItems)) {
                                    enumItem = ObjectHelper.GetFirstItemOfArrayByProperty(schemaColumn[0].EnumItems, 'Id', obj[fieldNames[i]]);
                                }
                                break;
                        }
                        //console.log(9999, obj[fieldNames[i]], schemaColumn[0], enumItem);
                        let valFormated: any = dataTableCellFormat.toView(obj[fieldNames[i]], schemaColumn[0].Type_FK, null, enumItem);
                        if (ObjectHelper.IsNullOrUndefined(valFormated)) {
                            valFormated = "";
                        }
                        if (valFormated.endsWith(',00')) {
                            valFormated = valFormated.substring(0, valFormated.length - ',00'.length);
                        }
                        if (fieldNames[i].endsWith('_MainProjection_Icon')) {
                            valFormated = SystemService.Instance.GetIconByEntity(schemaColumn[0].EntityNameType_FK);
                        }
                        result = result.replace('{' + fieldNames[i] + '}', valFormated);
                    }
                }
            }
        }
        return result;
    }
}